import React from 'react';
import Grid from '@mui/material/Grid';
import { Tooltip } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import NotesTypeField from './NotesTypeField';
import { Colors } from '../../assets/theme/Colors';

const LocationNotes = ({
  label = 'Internal Location Notes',
  tooltipLabel = 'These notes are not visible to the food donor.',
}) => {
  return (
    <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid item xs>
        <NotesTypeField
          name="notes"
          fullWidth
          multiline
          maxRows={5}
          type="textarea"
          variant="outlined"
          label={label}
        />
      </Grid>
      <Grid item xs={1}>
        <Tooltip arrow placement="top" title={tooltipLabel}>
          <HelpIcon htmlColor={Colors.blue.main} />
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default LocationNotes;
